import { Page } from '@/components';
import DAIEventsTable from './DAIEventsTable';
import HistoricTabs from './HistoricTabs';
import { CryptoIcon, ArrowSwitchIcon, Flex, Heading } from '@blockanalitica/ui';
import { tokensMapping } from '@/utils/tokens';
import { KpiEntityName } from '@/components';
export default function DAIEventsPage() {
  return (
    <Page
      title={
        <Flex gap="2xs" alignItems="center">
          <KpiEntityName
            symbol1={<CryptoIcon name="DAI" size="3" />}
            symbol2={
              <CryptoIcon
                name="USDS"
                address={tokensMapping('USDS').address}
                size="3"
              />
            }></KpiEntityName>
          <Heading size="1">
            <Flex gap="xs" alignItems="center">
              DAI <ArrowSwitchIcon /> USDS Activity
            </Flex>
          </Heading>
        </Flex>
      }>
      <HistoricTabs />
      <DAIEventsTable />
    </Page>
  );
}
